<!-- eslint-disable no-unused-vars -->
<template>
    <DxButton @click="refreshAll"></DxButton>
    <div class="flex flex-col h-full">
        <ai-grid-edit-core
            ref="stateContarctsGridRef"
            :meta="contractsMeta"
            :toolbar-config="toolbarConfig1"
            :data-source="stateContarctsGrid.dataSource"
            :lookups-data="stateContarctsGrid.lookupDataSource"
            :locked-rows="stateContarctsGrid.lockedRows"
            :editing="{ enableDeleting: true, allowAdding: true, allowUpdating: true }"
            @saveClick="onSaveClick"
            @onFocusChanged="onFocusChanged"
            @cellClick="cellClick"
            @refreshClick="refreshClick"
            @user-settings-changed="onUserSettingsChanged"
            @user-settings-reset="onUserSettingsReset"
            @user-data-changed="onUserDataChanged"
        >
        </ai-grid-edit-core>
        <ai-grid-edit-core
            ref="stateContractsPrilRef"
            :meta="prilMeta"
            :locked-rows="stateContractsPrilGrid.lockedRows"
            :toolbar-config="toolbarConfig2"
            :lookups-data="stateContractsPrilGrid.lookupDataSource"
            :data-source="stateContractsPrilGrid.dataSource"
            :editing="{ enableDeleting: true, allowAdding: true, allowUpdating: true }"
            @saveClick="onSaveClick"
            @onFocusChanged="onFocusChanged"
            @cellClick="cellClick"
            @refreshClick="refreshClick"
            @user-settings-changed="onUserSettingsChanged"
            @user-settings-reset="onUserSettingsReset"
            @user-data-changed="onUserDataChanged"
        >
        </ai-grid-edit-core>
    </div>
</template>

<script>
export default {
    name: 'vid-dog-pril-view',
};
</script>

<script setup>
// eslint-disable-next-line no-unused-vars
import { onBeforeMount, onMounted, reactive, ref } from 'vue';
import { commitDataChanges, getDataSource } from '@/service/meta-service';
// eslint-disable-next-line no-unused-vars
import { meta, contractsMeta, prilMeta } from './data.js';
// eslint-disable-next-line no-unused-vars
import {
    deleteUserDataChanges,
    getUserDataChanges,
    getUserSettingsChanges,
    saveUserDataChanges,
} from '@/service/userdata-service.js';
import { dxUiNotify } from '@/utils/dx-helper.js';
// eslint-disable-next-line no-unused-vars
import AiGridEditCore from '@/components/ai-grid-edit/ai-grid-edit-core.vue';
import AiCustomConfirmDialog from '@/utils/ai-custom-confirm-dialog.js';
// eslint-disable-next-line no-unused-vars
const stateContarctsGrid = reactive({
    lookupDataSource: {},
    prefState: true,
    selectedRowKeys: [],
    gridChanges: [],
    userSettings: {},
    dataSource: [],
    gridInstance: {},
    lockedRows: [],
    focusedRow: 0,
    keyExpr: 'kod_vdog',
    isLoaded: false,
    validationErrorsList: [],
    systemErrorIds: [],
    test: false,
    focusedRowIndex: 0,
});
// eslint-disable-next-line no-unused-vars
const stateContarctsGridRef = ref();
// eslint-disable-next-line no-unused-vars
const stateContractsPrilGrid = reactive({
    lookupDataSource: {},
    prefState: true,
    selectedRowKeys: [],
    gridChanges: [],
    userSettings: {},
    dataSource: [],
    gridInstance: {},
    gridRef: {},
    lockedRows: [],
    focusedRow: 0,
    keyExpr: 'kod_namepril',
    isLoaded: false,
    validationErrorsList: [],
    systemErrorIds: [],
    focusedRowIndex: 0,
});
// eslint-disable-next-line no-unused-vars
const stateContractsPrilRef = ref({});
const isUserDataLoaded = ref(false);
const initLoading = ref();
onMounted(async () => {
    console.log('onMounted');
    isUserDataLoaded.value = false;
    stateContarctsGrid.gridInstance = stateContarctsGridRef.value.gridInstance;
    stateContractsPrilGrid.gridInstance = stateContractsPrilRef.value.gridInstance;
    await setDataSource('core./core/ksvdog-view-select/get', {}, stateContarctsGrid);
    await fetchAndSetUserData({ viewId: contractsMeta.viewId }, stateContarctsGrid);
    await fetchAndSetUserSettings({ viewId: contractsMeta.viewId }, stateContarctsGrid);

    await fetchAndSetUserData({ viewId: prilMeta.viewId }, stateContractsPrilGrid);
    await fetchAndSetUserSettings({ viewId: prilMeta.viewId }, stateContractsPrilGrid);

    const gridContractsState = stateContarctsGrid.gridInstance.state();
    const updatedGridContractsState = {
        ...gridContractsState,
        ...stateContarctsGrid.userSettings,
        selectedRowKeys: stateContarctsGrid.selectedRowKeys,
    };
    stateContarctsGrid.gridInstance.state(updatedGridContractsState);
    stateContarctsGrid.gridInstance.option('editing.changes', stateContarctsGrid.gridChanges);

    const gridContractsPrilState = stateContractsPrilGrid.gridInstance.state();
    const updatedContractsPrilGridState = {
        ...gridContractsPrilState,
        ...stateContractsPrilGrid.userSettings,
        selectedRowKeys: stateContractsPrilGrid.selectedRowKeys,
    };
    stateContractsPrilGrid.gridInstance.state(updatedContractsPrilGridState);
    stateContractsPrilGrid.gridInstance.option('editing.changes', stateContractsPrilGrid.gridChanges);
    console.log('mounted', stateContractsPrilGrid, stateContarctsGrid);
    isUserDataLoaded.value = true;
    initLoading.value = true;
});

// eslint-disable-next-line no-unused-vars
const fetchAndSetUserSettings = async (args, ds) => {
    const { result, settings } = await getUserSettingsChanges(args);

    if (result && settings) {
        ds.userSettings = settings;
        setPrefState(settings, ds);
    } else {
        ds.userSettings = {};
        ds.prefState = true;
    }
};
// eslint-disable-next-line no-unused-vars
const cellClick = async (componentName, key) => {
    const ds = getStateByComponentName(componentName);
    const isRowDisabled = ds.lockedRows.includes(key);
    if (isRowDisabled) {
        const result = await AiCustomConfirmDialog(
            'Изменение текущей строки заблокировано, \n сохраните или отмените изменения в завсимых компонентах ',
            'Существуют несохраненные данные!',
            false
        );
        if (result === 1) {
            // onSaveClick(processedData);
            return;
        }
        if (result === -1) return;
    }
};
// eslint-disable-next-line no-unused-vars
const refreshClick = async (gridChanges, processedData, metaData) => {
    const ds = getStateByComponentName(metaData.viewId);
    if (gridChanges.length > 0) {
        const result = await AiCustomConfirmDialog('Сохранить изменения?', 'Запрос на сохранение');

        if (result === 1) {
            // onSaveClick(processedData);
            return;
        }
        if (result === -1) return;
    }

    isUserDataLoaded.value = false;
    ds.gridInstance.option('editing.changes', []);
    ds.gridInstance.clearSelection();
    isUserDataLoaded.value = true;

    // systemErrorIds.value = [];
    // validationErrorsList.value = [];
    let currentItem = meta.components.find(el => el.name === metaData.viewId);
    const { result, changes } = await getUserDataChanges({ viewId: metaData.viewId });
    if (result && changes) await deleteUserDataChanges({ viewId: metaData.viewId });

    await fetchAndSetUserData({ viewId: metaData.viewId }, ds);
    await setDataSource(currentItem.selectUrl, {}, ds);

    dxUiNotify('Данные обновлены', 'success');
};

const setPrefState = (settings, ds) => {
    if (!settings) {
        ds.prefState = true;
        return;
    }
    switch (settings.preferencesState) {
        case false:
            ds.prefState = false;
            break;
        case undefined:
        case null:
        case true:
        default:
            ds.prefState = true;
            break;
    }
};

const setDataSource = async (url, args, ds) => {
    const { result, data } = await getDataSource(url, args);
    // ds.lookupDataSource = data ? getLookUpsDs(data) : [];
    ds.dataSource = result && Array.isArray(data) ? data : [];
};
// eslint-disable-next-line no-unused-vars
const onUserDataChanged = async (userData, viewId) => {
    console.log('user data changed', userData);
    if (!isUserDataLoaded.value) return;
    const ds = getStateByComponentName(viewId);
    const args = {
        viewId: viewId,
        instanceId: null,
        changes: { ...userData, focusedRow: ds.focusedRow, focusedRowIndex: ds.focusedRowIndex },
    };
    ds.gridChanges = userData.gridChanges;
    ds.focusedRow = userData.focusedRow;
    ds.focusedRowIndex = userData.focusedRowIndex;
    await saveUserDataChanges(args);
    // await fetchAndSetUserData({ viewId: viewId }, ds);
    if (viewId) {
        lockAncestors(viewId, userData.gridChanges);
    }
};
// eslint-disable-next-line no-unused-vars
const lockAncestors = (viewId, gridChanges) => {
    // ченджи имеются
    if (gridChanges.length > 0) {
        const ancestors = getAncestorsGrids(viewId);
        ancestors.forEach(ancestor => {
            const ds = getStateByComponentName(ancestor.name);

            // собрала блок строчки
            if (ds.lockedRows.length === 0) {
                ds.lockedRows = ds.dataSource.filter(el => el[ds.keyExpr] !== ds.focusedRow).map(el => el[ds.keyExpr]);
                // тулбар выкл
                ds.gridInstance.option('toolbar').items.forEach(el => {
                    if (el.options) el.options.disabled = true;
                    el.disabled = true;
                });
            }

            // Рекурсивно вызываем lockAncestors для предков

            lockAncestors(ancestor.name, ds.gridChanges);
        });
    } else {
        const ancestors = getAncestorsGrids(viewId);
        ancestors.forEach((ancestor, index) => {
            const ds = getStateByComponentName(ancestor.name);

            // Проверяем, есть ли изменения в этом узле

            // Сбрасываем lockedRows
            if (index === 0 && hasChildrensGridChanges(ancestor.name)) {
                if (ds.lockedRows.length !== 0) {
                    ds.lockedRows = [];
                    // Включаем элементы тулбара
                    ds.gridInstance.option('toolbar').items.forEach(el => {
                        if (el.options) el.options.disabled = false;
                        el.disabled = false;
                    });
                }
            }
            lockAncestors(ancestor.name, ds.gridChanges);
        });
    }
};
// eslint-disable-next-line no-unused-vars
const onSaveClick = async (userChanges, event, metaData) => {
    const ds = getStateByComponentName(metaData.viewId);
    const parentfocusedRow = meta.components.find(el => el.id === metaData.parentComponent);
    const parentDs = getStateByComponentName(parentfocusedRow.name);
    const { errors, validationErrors } = await commitDataChanges(metaData.save, userChanges, {});
    const args = { select_args: { select_args: parentDs.focusedRow + 5 } };
    if (errors.length === 0 && validationErrors.length === 0) {
        await setDataSource(metaData.selectUrl, args, ds);
        ds.gridInstance.option('editing.changes', []);
        dxUiNotify('Изменения данных прошли успешно', 'success');
        return;
    }

    if (validationErrors.length > 0) {
        const validationErrorIds = validationErrors.map(err => err.item.greyEminence);
        ds.validationErrorsList = [...validationErrors];

        const filteredChanges = ds.gridInstance
            .option('editing.changes')
            .filter(change => validationErrorIds.includes(change.key));

        ds.gridInstance.option('editing.changes', filteredChanges);

        await setDataSource(metaData.selectUrl, args);

        dxUiNotify('Validation failed', 'error');
        return;
    }

    if (errors.length > 0) {
        const errorMsgs = [];

        errors.forEach(error => {
            ds.systemErrorIds.push(error.item.greyEminence);
            errorMsgs.push(error.message);
        });

        const filteredChanges = ds.gridInstance
            .option('editing.changes')
            .filter(change => ds.systemErrorIds.includes(change.key));

        ds.gridInstance.option('editing.changes', filteredChanges);

        await setDataSource(metaData.selectUrl, args);
        dxUiNotify('wewe', 'error');
        return;
    }
};
// eslint-disable-next-line no-unused-vars
const onFocusChanged = (row, componentName, rowIndex, component) => {
    if (rowIndex === -1) {
        return;
    }

    const children = getAllChildren(componentName);
    const state = getStateByComponentName(componentName);
    console.log('state', state);
    state.focusedRow = state.gridInstance.option('focusedRowKey');
    state.focusedRowIndex = state.gridInstance.option('focusedRowIndex');
    children.forEach(async el => {
        const ds = getStateByComponentName(el.name);
        const focusedRow = state.dataSource.find(el => el[state.keyExpr] === state.focusedRow);
        ds && (await fetchAndSetUserData({ viewId: componentName }, ds));
        ds && (await setDataSource(el.selectUrl, { select_args: { kod_vdog: focusedRow.kod_vdog, ntep_el: 1 } }, ds));
        ds.gridInstance.option('focusedRowIndex', -1);
        ds.gridInstance.option('focusedRowIndex', 0);
        lockAncestors(componentName, ds.gridChanges);
    });
};

// eslint-disable-next-line no-unused-vars
const getAllChildren = componentName => {
    const children = [];
    let currentItem = meta.components.find(el => el.name === componentName);

    const parent = meta.components.filter(item => {
        return item.parentComponent === currentItem.id;
    });
    if (parent) {
        children.push(...parent);
    }
    return children;
};
// eslint-disable-next-line no-unused-vars
const hasChildrensGridChanges = componentName => {
    const children = [];
    const currentItem = meta.components.find(el => el.name === componentName);

    const traverseChildren = component => {
        const childComponents = meta.components.filter(item => {
            return item.parentComponent === component.id;
        });
        children.push(...childComponents);
        childComponents.forEach(child => {
            traverseChildren(child);
        });
    };

    if (currentItem) {
        traverseChildren(currentItem);
    }
    const childrenGridChanges = children.filter(el => {
        const ds = getStateByComponentName(el.name);
        return ds.gridChanges.length > 0;
    });
    return childrenGridChanges.length > 0 ? false : true;
};

const getAncestorsGrids = componentName => {
    let currentItem = meta.components.find(el => el.name === componentName);
    const ancestors = [];
    let currentParentId = currentItem.parentComponent;
    while (currentParentId) {
        const parent = meta.components.find(item => item.id === currentParentId);
        ancestors.push(parent);
        currentParentId = parent.parentComponent;
    }
    return ancestors;
};
// eslint-disable-next-line no-unused-vars
const getStateByComponentName = componentName => {
    switch (componentName) {
        case 'ksvdog-view': {
            return stateContarctsGrid;
        }
        case 'vdognamepril-view': {
            return stateContractsPrilGrid;
        }
    }
};
// eslint-disable-next-line no-unused-vars
const fetchAndSetUserData = async (args, ds) => {
    const { result, changes } = await getUserDataChanges(args);
    if (result && changes) {
        const { selectedRowKeys, gridChanges, lookupData } = changes;
        ds.selectedRowKeys = selectedRowKeys ? selectedRowKeys : [];
        ds.gridChanges = gridChanges ? gridChanges : [];
        ds.focusedRowIndex = gridChanges.focusedRowIndex;
        ds.focusedRow = gridChanges.focusedRow;
        if (lookupData) {
            Object.keys(ds.lookupDataSource).forEach(key => {
                ds.lookupDataSource[key] = [...ds.lookupDataSource[key], ...lookupData];
            });
        }
    }
};

// eslint-disable-next-line no-unused-vars
const getLookUpsDs = dataSource => {
    const columns = getLookupColumns(dataSource);
    const lookups = {};
    for (const col of columns) {
        const lookupDs = generateLookupDs(col, dataSource);
        lookups[col.dataField] = lookupDs;
    }

    return lookups;
};
// eslint-disable-next-line no-unused-vars
const getLookupColumns = metaColumns => {
    const columns = [];
    for (const col of metaColumns) {
        if (col.editor) {
            const isLookupEditor = col.editor.type === 'ai-drop-down' || col.editor.type === 'ai-popup';
            if (isLookupEditor) {
                columns.push(col);
            }
        }
    }
    return columns;
};
// eslint-disable-next-line no-unused-vars
const generateLookupDs = (col, ds) => {
    const lookupDs = [];
    for (const row of ds) {
        const lookupRow = {};
        lookupRow[col.dataField] = row[col.dataField];
        lookupRow[col.editor.text] = row[col.editor.text];
        lookupDs.push(lookupRow);
    }
    lookupDs.push({ id_ro_grid_11_popup: 9, name_ro_11: 'hi' });
    return lookupDs;
};
// eslint-disable-next-line no-unused-vars
const toolbarConfig1 = reactive({
    order: [
        {
            name: 'refreshButton',
        },
        {
            name: 'selectButton',
        },
        {
            name: 'copyButton',
        },
        {
            name: 'addRowButton',
        },
        {
            name: 'deleteButton',
        },
        {
            name: 'saveButton',
        },
    ],
});

// eslint-disable-next-line no-unused-vars
const toolbarConfig2 = reactive({
    order: [
        {
            name: 'refreshButton',
        },
        {
            name: 'selectButton',
        },
        {
            name: 'copyButton',
        },
        {
            name: 'addRowButton',
        },
        {
            name: 'deleteButton',
        },
        {
            name: 'saveButton',
        },
    ],
});
</script>

<style scoped></style>
